document.addEventListener('DOMContentLoaded', () => {

    function setError(form, field, error) {
        const $div = form
            .find(`div.js-form-item input[name="${field}"]`)
            .parents("div.js-form-item");
        $div.addClass("error-item");
        $div.addClass("error-tooltip");
        $div.append(`<div class="error__tooltip"><span>${error}</span></div>`);
    }

    function removeErrors(form) {
        const $elements = form.find(`div.js-form-item`);
        $elements.removeClass("error-item");
        $elements.removeClass("error-tooltip");
        for (let index = 0; index < $elements.length; index++) {
            const $element = $($elements[index]);
            $element.find("input").removeClass("error");
            $element.find("div.error__tooltip").remove();
        }
    }


    const $forms = $("form.eventRegistrationForm")
    const $formModal = $("section.js-modal, section.js-small-form-modal, section.js-short-form-modal");

    console.log($forms)

    $forms.on('submit', (e) => {
        e.preventDefault()
        const $currentForm = $(e.currentTarget)
        const $submitButton = $currentForm.find('button[type="submit"]')
        let serialize = $currentForm.serializeArray();

        removeErrors($forms)

        $submitButton.addClass("form__submit--load");
        $submitButton.prop("disabled", true);

        $.ajax({
            url: $currentForm.attr("action"),
            method: "post",
            data: serialize,
        }).done((res) => {
            if (res.status) {
                $formModal.removeClass("active");
                $forms
                    .closest(".js-short-form")
                    .removeClass("over transition active");
                setTimeout(() => {
                    document.querySelector("section.js-modal-success").classList.add("active");
                }, 500);
                $forms.trigger("reset");
                if (window.ANALYTICS_ENABLED == true) {
                    (dataLayer = window.dataLayer || []).push({
                        'eCategory': 'Form',
                        'eAction': 'sent',
                        'eLabel': '',
                        'event': 'GTMForms'
                    });
                }
            } else {
                for (const [field, errors] of Object.entries(res.form_errors)) {
                    setError($currentForm, field, errors[0]);
                }
            }
        }).always(() => {
            $submitButton.removeClass("form__submit--load");
            $submitButton.prop("disabled", false);
        })
    })

})
